query UserSetupCommon {
  userRankTypes(
    filter: { isInternalUse: { notEqualTo: true } }
    orderBy: USER_RANK_ASC
  ) {
    nodes {
      id
      _rowTimestamp
      userRank
      sortOrder
      _isUpdatable
      _isDeletable
    }
  }
  secureRowLevels(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
}
